import { useEffect, useState } from 'react';
import axios from 'axios';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { setJsonLd } from '../../lib/seo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FaqRow = ({ item, i }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#E6DAC5]" data-testid={`faq-item-${i}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid={`faq-toggle-${i}`} className="w-full flex items-center justify-between gap-6 py-5 text-left group">
        <span className="font-display text-xl text-[#1E1622] group-hover:text-[#3B164C] transition-colors">{item.q}</span>
        <span className="flex-shrink-0 w-8 h-8 rounded-full border border-[#E6DAC5] flex items-center justify-center text-[#3B164C]">{open ? <Minus size={16} /> : <Plus size={16} />}</span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
            <p className="pb-6 text-[#1E1622]/70 leading-relaxed font-light max-w-3xl" data-testid={`faq-answer-${i}`}>{item.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const FaqSection = ({ slug, destination }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/faqs/${slug}`).then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, [slug]);
  useEffect(() => {
    setJsonLd('faq', items.length ? { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })) } : null);
    return () => setJsonLd('faq', null);
  }, [items]);
  if (!items.length) return null;
  return (
    <section className="max-w-4xl mx-auto mb-20" data-testid="destination-faqs">
      <span className="eyebrow mb-4"><span className="w-10 h-px bg-[#C5A059]" /> Questions</span>
      <h2 className="font-display text-3xl md:text-4xl text-[#1E1622] mb-6">Moving to {destination}: your questions answered</h2>
      <div className="border-t border-[#E6DAC5]">{items.map((f, i) => <FaqRow key={f.q} item={f} i={i} />)}</div>
    </section>
  );
};
